import { render, staticRenderFns } from "./DashboardUserWidget.vue?vue&type=template&id=3cfcab74&scoped=true&"
import script from "./DashboardUserWidget.vue?vue&type=script&lang=ts&"
export * from "./DashboardUserWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfcab74",
  null
  
)

export default component.exports